import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-confirmation-action',
    imports: [],
    templateUrl: './confirmation-action.component.html',
    styleUrl: './confirmation-action.component.scss'
})
export class ConfirmationActionComponent {
  @Input() icon: string = ''
  @Input() iconBgColor: string = '#FFF3E5'
  @Input() title: string = ''
  @Input() description: string = ''
  @Input() confirmLabel: string = 'Confirm'
  @Input() cancelLabel: string = 'Cancel'
  @Input() confirmBtnClass: string = 'btn-secondary-outline'
  @Input() showCancel: boolean = true
  @Input() disabled: boolean = false
  @Output() onConfirm = new EventEmitter<void>()
  @Output() onCancel = new EventEmitter<void>()

  confirm () {
    this.onConfirm.emit()
  }

  cancel () {
    this.onCancel.emit()
  }
}
